import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  HomescreenSettings, ILanguage, IPushChannel, IWeatherStyle, IWeatherWindUnit,
  PersonalContactDetails,
} from './settings.models';

/** Settings changes, almost all of them triggered by the user. */
export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    /** Seeds the homescreen without triggering an upload. */
    'Homescreen Initialized': props<{ homescreen: HomescreenSettings }>(),
    /** A user-made change — this is what gets persisted to the backend. */
    'Homescreen Updated': props<{ homescreen: HomescreenSettings }>(),
    'Toggle Canteen Remember': props<{ enabled: boolean }>(),
    'Change Remembered Canteen': props<{ canteenId: string | null }>(),
    'Toggle Departure Remember': props<{ enabled: boolean }>(),
    'Change Remembered Station': props<{ stationId: string | null }>(),
    'Change Remembered Navi Categories': props<{ categories: number[] }>(),
    'Toggle Push': props<{ enabled: boolean }>(),
    'Toggle Push Channel': props<{ channel: IPushChannel; enabled: boolean }>(),
    'Change Language': props<{ language: ILanguage }>(),
    'Toggle Weather': props<{ enabled: boolean }>(),
    'Change Weather Style': props<{ style: IWeatherStyle }>(),
    'Change Weather Wind Unit': props<{ windUnit: IWeatherWindUnit }>(),
    'Update Personal Contact Details': props<{ personalContactDetails: PersonalContactDetails }>(),
    'Reset Settings': emptyProps(),

    /**
     * Seeds `lastRevision` for an installation that predates this bookkeeping. Dispatched
     * at most once in the lifetime of an installation, and only when storage held no
     * wizard state at all.
     */
    'Wizard bootstrapped': props<{ lastRevision: number | null }>(),
    /**
     * Fills the queue with everything that became due since the recorded revision and
     * advances that revision — in one reduction, so a start that shows nothing cannot lose
     * a step that was due.
     */
    'Wizard started': emptyProps(),
    /** Worked off. Removes the step from the queue for good. */
    'Wizard step completed': props<{ id: string }>(),
  },
});

/** Results reported back by the settings backend. */
export const SettingsApiActions = createActionGroup({
  source: 'Settings API',
  events: {
    'Homescreen Upload Succeeded': emptyProps(),
    'Homescreen Upload Failed': props<{ reason: string }>(),
    /** Background refresh could not reach the backend — the local state stays as it is. */
    'Homescreen Fetch Failed': props<{ reason: string }>(),
  },
});
